var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.000000000000001,0,0,1.000000000000001,-2.8421709430404007e-13,64.99999999999974)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M512 58.668v266.664c0 32.43-26.238 58.668-58.668 58.668H58.668c-5.336 0-10.453-.64-15.148-2.133C18.348 375.254 0 352.426 0 325.332V58.668C0 26.238 26.238 0 58.668 0h394.664C485.762 0 512 26.238 512 58.668zm0 0",
    opacity: 1,
    "data-original": "#eceff1",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8807",
    d: "M149.332 106.668c0 23.562-19.102 42.664-42.664 42.664C83.102 149.332 64 130.23 64 106.668 64 83.102 83.102 64 106.668 64c23.562 0 42.664 19.102 42.664 42.668zm0 0",
    opacity: 1,
    "data-original": "#ffc107",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M512 276.055v49.277c0 32.43-26.238 58.668-58.668 58.668H58.668c-5.336 0-10.453-.64-15.148-2.133l260.695-260.695c14.504-14.504 38.398-14.504 52.906 0zm0 0",
    opacity: 1,
    "data-original": "#388e3c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M363.945 384H58.668c-5.336 0-10.453-.64-15.148-2.133C18.348 375.254 0 352.426 0 325.332v-6.613l122.879-122.88c14.508-14.507 38.402-14.507 52.906 0zm0 0",
    opacity: 1,
    "data-original": "#4caf50",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.66b5c5a9e8924ea7408311d5a4fc83fe.svg";
export { ForwardRef as ReactComponent };